$('document').ready(function(){
  function handleSelection() {
  var selectedMaterialGroup = $('.material-item.selected').attr('data-group');
  var shipping_time = $('.material-item.selected').attr('data-leadtime');
  var material = $('.material-item.selected.segmentsMaterial').attr('data-display-title');
  var metal = $('.material-item.segmentMetal.selected').attr('data-display-title'); 
  var glass = $('.material-item.segmentGlass.selected').attr('data-display-title');
  var wood = $('.material-item.segmentWood.selected').attr('data-display-title');
  var select_option = $('#var_get1412 select#SingleOptionSelector-1').find(":selected").val();
  var select_option_2 = $('#var_get1412 select#SingleOptionSelector-2').find(":selected").val();
      $('.material-item.selected').each(function(){
      var load_img = $(this).attr('data-image');
      var optionName = $(this).attr('data-display-title');
      var materialSelectorGroup = $(this).closest('.materials').attr('data-material-options');
      $('.material-selector[data-material-options="' + materialSelectorGroup + '"] .swatch-selected-value').attr('data-display-title', optionName);
      $('.material-selector[data-material-options="' + materialSelectorGroup + '"] .swatch .swatch-image').css('background-image','url('+load_img+')');
      });

 var finalop = '';
         if (selectedMaterialGroup) {
            finalop += selectedMaterialGroup;
          }
         if (select_option) {
            finalop += (finalop ? ' / ' : '') + select_option;
          }
        if (select_option_2) {
          finalop += (finalop ? ' / ' : '') + select_option_2;
        }
   $('.custom__variantcomb option').removeAttr('selected');
     
        var comoboo_cst_mm = $(".custom__variantcomb option").map(function() {
            return $(this).text().trim();
        }).get();
     
      $('.custom__variantcomb option').removeAttr("selected");  
     
          if(jQuery.inArray(finalop.toString(), comoboo_cst_mm) >= 0){  
            
          $('.custom__variantcomb option').filter(function() {
                return $(this).text().trim() === finalop;
            }).attr("selected", "selected");
            
          var selected_product_id = $(".custom__variantcomb").find(":selected").val();
           var price = $(".custom__variantcomb").find(":selected").attr('variant-data-price');
            var compare_price = $(".custom__variantcomb").find(":selected").attr('variant_compare-price');
            var percent_discount = $(".custom__variantcomb").find(":selected").attr('percent-discount');
          var sku = $(".custom__variantcomb").find(":selected").attr('data-var-sku');
          var qtyval = $(".custom__variantcomb").find(":selected").attr('qty'); 
          var var_img = $(".custom__variantcomb").find(":selected").attr('data-img'); 
            
          $('.custom_table_products').val(selected_product_id);  
          $('.product__media-item.is-active .product__media img').attr('src', var_img);
          $('.product__media-item.is-active .product__media img').attr('srcset', var_img);
          $('#demo2-1').html(select_option);
          $(".custom_main__price").html(price);
            $('.custom_compareprice').html(compare_price);
            $('.custom_per_dis').html(percent_discount);
          $('.table_shipping').val(shipping_time);
          $('.table_sku').val(sku);
          $('.detailss__sku').html(sku);
          $('.table_material').val(material);  
          $('.table_metal').val(metal);  
          $('.table_glass').val(glass);
          $('.table_wood').val(wood);
          if(qtyval == 'true')
           {
            setTimeout(function(){
              $('.button_table').removeAttr('disabled').find('span').text('Add to cart');
            }, 100);  
         }
          }
  }
          $('select#SingleOptionSelector-1').on('change', handleSelection);
          $('select#SingleOptionSelector-2').on('change', handleSelection);
          $('.material-item').on('click', handleSelection);
  handleSelection();
});